exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SliderVcDemo h4[data-v-3ad8954e]{color:#066}.SliderVcDemo .demoItem[data-v-3ad8954e]{padding:10px 0;font-size:18px;border-bottom:1px dotted #999}", ""]);

// exports
